/** Task list and task page strings (phase 1, block "tasks"). */
export const tasks = {
  'tasks.title': 'Задачі',
  'tasks.new': 'Нова задача',
  'tasks.filter.allBusinesses': 'Усі бізнеси',
  'tasks.filter.anyAssignee': 'Будь-який виконавець',
  'tasks.filter.search': 'Пошук за назвою',
  'tasks.chip.active': 'Активні',
  'tasks.col.number': '№',
  'tasks.col.title': 'Назва',
  'tasks.col.business': 'Бізнес',
  'tasks.col.project': 'Проєкт',
  'tasks.col.status': 'Статус',
  'tasks.col.assignee': 'Виконавець',
  'tasks.col.priority': 'Пріоритет',
  'tasks.col.due': 'Термін',
  'tasks.col.updated': 'Оновлено',
  'tasks.shown': 'Показано {shown} з {total} · сторінка {page}',
  'tasks.prev': 'Назад',
  'tasks.next': 'Далі',
  'tasks.empty': 'Задач за цими умовами немає',
  'tasks.noBusinesses': 'Спочатку створи бізнес у розділі «Бізнеси».',

  'tasks.status.backlog': 'беклог',
  'tasks.status.planned': 'заплановано',
  'tasks.status.in_progress': 'в роботі',
  'tasks.status.review': 'рев’ю',
  'tasks.status.waiting_human': 'чекає людину',
  'tasks.status.done': 'зроблено',
  'tasks.status.rejected': 'відхилено',
  'tasks.status.deferred': 'відкладено',

  'tasks.priority.low': 'низький',
  'tasks.priority.normal': 'звичайний',
  'tasks.priority.high': 'високий',
  'tasks.priority.urgent': 'терміновий',

  'tasks.form.business': 'Бізнес',
  'tasks.form.title': 'Назва',
  'tasks.form.project': 'Проєкт',
  'tasks.form.description': 'Опис',
  'tasks.form.priority': 'Пріоритет',
  'tasks.form.due': 'Термін',
  'tasks.form.assignee': 'Виконавець',
  'tasks.form.none': '—',
  'tasks.form.agentsLater': 'агента призначає кнопка «Доручити агенту»',
  'tasks.form.create': 'Створити',
  'tasks.form.mobileHint': 'На мобільному ця панель відкривається на весь екран.',

  'task.loading': 'Завантаження задачі…',
  'task.notFound': 'Задачу не знайдено',
  'task.edit': 'Редагувати',
  'task.status': 'Статус',
  'task.field.business': 'Бізнес',
  'task.field.project': 'Проєкт',
  'task.field.assignee': 'Виконавець',
  'task.field.priority': 'Пріоритет',
  'task.field.due': 'Термін',
  'task.field.process': 'Процес',
  'task.field.relations': 'Зв’язки',
  'task.field.version': 'Версія',
  'task.version.line': '{version} · оновлено {when} · {who}',
  'task.description': 'Опис',
  'task.description.empty': 'Опису поки немає.',
  'task.plan.hint': 'План (з фази 5) з’явиться тут: кроки, артефакти, затвердження.',
  'task.discussion': 'Обговорення',
  'task.comment.placeholder': 'Написати коментар…',
  'task.comment.send': 'Надіслати',
  'task.comment.reply': 'Відповісти',
  'task.comment.replying': 'Відповідь на коментар',
  'task.comment.none': 'Коментарів ще немає.',
  'task.comment.edit': 'Редагувати',
  'task.comment.edited': 'змінено',
  'task.history': 'Історія',
  'task.history.created': '{who} — створено задачу',
  'task.history.created.assignee': ', виконавець: {to}',
  'task.history.created.due': ', термін {to}',
  'task.history.status': '{who} — статус: {from} → {to}',
  'task.history.assignee': '{who} — виконавець: {to}',
  'task.history.due': '{who} — термін: {to}',
  'task.history.priority': '{who} — пріоритет: {from} → {to}',
  'task.history.comment': '{who} — додано коментар',
  'task.history.edited': '{who} — змінено: {fields}',
  'task.history.relation': '{who} — додано зв’язок',
  'task.history.relation_removed': '{who} — прибрано зв’язок',
  'task.history.other': '{who} — {action}',
  'task.history.field.title': 'назву',
  'task.history.field.description': 'опис',
  'task.history.field.projectId': 'проєкт',
  'task.conflict': 'Задачу змінено, онови сторінку',
  'task.reload': 'Оновити сторінку',
  'task.relation.blocks': 'блокує',
  'task.relation.relates': 'пов’язана',
  'task.relation.client': 'клієнт',
  'task.relation.asset': 'файл',
  'task.relation.blockedBy': 'блокується',
  'task.relation.add': '+',
  'task.relation.kind': 'Тип зв’язку',
  'task.relation.target': 'Задача',
  'task.relation.search': 'Пошук задачі за назвою',
  'task.relation.remove': 'Прибрати',
  'task.today': 'сьогодні',
  'task.yesterday': 'вчора',
  'task.someone': 'Система',
} as const;
